/*
  Yulan v3p - fiche produit : changer de format (slim / jumbo / booster / carton…) sans recharger la page.
  Les formats sont des produits distincts (bloc « Format », snippets/yulan-v3-formats-block.liquid, liens
  .yv3-fmt vers /products/<autre-handle>). Au clic, on demande à Shopify le rendu de toutes les sections
  de la page pour l'autre produit (API de rendu de sections : /products/<handle>?sections=id1,id2,…) et on
  remplace chaque section en place : galerie, colonne d'achat, tableau des prix, compagnons, recommandations,
  barre d'achat collante. Les scripts en ligne des sections sont réexécutés (titre au-dessus de la galerie…),
  l'adresse et le titre de l'onglet sont mis à jour, le bouton « Précédent » revient au produit d'avant.
  Sans JavaScript ou en cas d'erreur réseau, le lien classique prend le relais.
*/
(function () {
  'use strict';
  if (!window.fetch || !window.history || !window.DOMParser) return;
  var main = document.getElementById('MainContent');
  if (!main) return;
  // v3r : ce script est chargé depuis la colonne d'achat (bloc « Format »), que execScripts() réexécute à chaque
  // échange : sans ce verrou, les écouteurs se multipliaient (2, 4, 8… requêtes et entrées d'historique en double).
  // Une seule instance suffit : #MainContent n'est jamais remplacé et le clic est délégué au document.
  if (window.__yv3ProductSwitch) return;
  window.__yv3ProductSwitch = true;
  var busy = false;

  function sectionIds() {
    return Array.prototype.slice.call(main.querySelectorAll('[id^="shopify-section-"]'))
      .filter(function (el) { return el.parentNode === main || el.parentNode.parentNode === main; })
      .map(function (el) { return el.id.replace(/^shopify-section-/, ''); });
  }

  function execScripts(root) {
    Array.prototype.slice.call(root.querySelectorAll('script')).forEach(function (s) {
      if (s.type && s.type !== 'text/javascript' && s.type !== 'module' && s.type !== '') return;
      var n = document.createElement('script');
      Array.prototype.forEach.call(s.attributes, function (a) { n.setAttribute(a.name, a.value); });
      n.textContent = s.textContent;
      s.parentNode.replaceChild(n, s);
    });
  }

  function swapTo(href, push) {
    if (busy) return;
    busy = true;
    var ids = sectionIds();
    var clean = href.split('?')[0].split('#')[0];
    document.documentElement.classList.add('yv3-switching');
    // pas d'en-tête Accept: application/json — Shopify répondrait alors le JSON du produit (/products/x.json)
    // au lieu du rendu des sections ; avec l'Accept par défaut, l'API ?sections= renvoie bien le JSON attendu
    // (virgules non encodées : « %2C » fait répondre Shopify 400 ; et 5 sections maximum par requête,
    // sinon 400 aussi — la fiche en a 6, d'où plusieurs requêtes en parallèle)
    var groups = [];
    for (var i = 0; i < ids.length; i += 5) groups.push(ids.slice(i, i + 5));
    Promise.all(groups.map(function (g) {
      return fetch(clean + '?sections=' + g.join(','), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }))
      .then(function (maps) {
        var map = {};
        maps.forEach(function (m) { Object.keys(m).forEach(function (k) { map[k] = m[k]; }); });
        var replaced = 0;
        ids.forEach(function (id) {
          var html = map[id];
          var old = document.getElementById('shopify-section-' + id);
          if (typeof html !== 'string' || !old) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.body.firstElementChild;
          if (!fresh) return;
          fresh = document.importNode(fresh, true);
          old.parentNode.replaceChild(fresh, old);
          execScripts(fresh);
          replaced++;
        });
        if (!replaced) throw new Error('rien à remplacer');
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(main);
        var h1 = main.querySelector('.yv3-title-top h1, .product__title h1, .product__title .h1');
        if (h1) document.title = h1.textContent.trim() + ' – Yulan TCG';
        // v3s : le fil d'Ariane réel est nav.yv3-crumb (l'ancien sélecteur ne trouvait rien)
        var crumb = document.querySelector('.yv3-crumb [aria-current="page"], .yv3-breadcrumb [aria-current="page"], .yulan-breadcrumb [aria-current="page"]');
        if (crumb && h1) crumb.textContent = h1.textContent.trim();
        if (push) history.pushState({ yv3Product: clean }, '', clean);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.dispatchEvent(new CustomEvent('yv3:product-switched', { detail: { url: clean } }));
        // v3r : produit épuisé → l'application Kbite, qui surveille l'adresse de la page toutes les 500 ms, dessine
        // son bouton « Me prévenir du retour en stock » dans le nouvel #yulan-kbite-slot (snippets/buy-buttons.liquid).
        // Filet de sécurité : s'il n'est pas apparu au bout de 3 s (retour arrière pendant que Kbite travaillait…),
        // la page est rechargée normalement, sans nouvelle entrée d'historique.
        var kbiteActive = !!(window.initVar || document.querySelector('script[src*="staq-cdn.com/grow"]'));
        if (kbiteActive && main.querySelector('#yulan-kbite-slot.yulan-kbite-slot--soldout')) {
          setTimeout(function () {
            if (location.pathname !== clean) return; // le visiteur est déjà passé à autre chose
            var slot = main.querySelector('#yulan-kbite-slot.yulan-kbite-slot--soldout');
            if (slot && !slot.querySelector('.gw-button-widget')) location.replace(location.href);
          }, 3000);
        }
      })
      .catch(function () { location.href = href; })
      .then(function () { busy = false; document.documentElement.classList.remove('yv3-switching'); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.yv3-fmt');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('/products/') < 0) return;
    e.preventDefault();
    swapTo(href, true);
  });

  if (history.state === null && location.pathname.indexOf('/products/') >= 0) history.replaceState({ yv3Product: location.pathname }, '', location.href);
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.yv3Product && e.state.yv3Product !== location.pathname) return; // adresse déjà celle de l'état
    if (e.state && e.state.yv3Product) swapTo(e.state.yv3Product, false);
  });
})();
